import React from "react";
import Navbar from "../components/Navbar";
import ParticlesBackground from "../components/ParticlesBackground";

export default function AppLayout({ children }) {
  return (
    <div className="relative antialiased">
      {/* Particles background */}
      <ParticlesBackground />

      {/* Navbar */}
      <Navbar />

      {/* Main content */}
      <main className="relative z-10 max-w-[1600px] mx-auto mt-[120px] lg:mt-[150px]">
        {children}
      </main>
    </div>
  );
}
